/* RX Performance — Birthday Sale password page. Scoped, no dependencies. */
(function () {
  var MOBILE_QUERY = '(max-width: 749px)';
  var RETRY_KEY = 'rx-bp-retries';
  var MAX_RETRIES = 6;
  var FIRST_RETRY_MS = 9000;
  var RETRY_INTERVAL_MS = 15000;

  var instances = [];

  function isDesignMode() {
    return !!(window.Shopify && window.Shopify.designMode);
  }

  function init(root) {
    if (!root || root.rxBpBound) return;
    root.rxBpBound = true;

    var timers = [];
    var listeners = [];

    function every(fn, ms) {
      var id = window.setInterval(fn, ms);
      timers.push(id);
      return id;
    }
    function later(fn, ms) {
      var id = window.setTimeout(fn, ms);
      timers.push(id);
      return id;
    }
    function on(target, type, fn) {
      target.addEventListener(type, fn);
      listeners.push([target, type, fn]);
    }

    /* ---------- Background video (single source, poster fallback) ---------- */
    function prefersLightMedia() {
      var reduced = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
      var conn = navigator.connection || {};
      return reduced || conn.saveData === true;
    }

    function mountVideo() {
      if (root.getAttribute('data-video-enabled') !== 'true') return;
      if (prefersLightMedia()) return;

      var isMobile = window.matchMedia(MOBILE_QUERY).matches;
      var src = isMobile
        ? root.getAttribute('data-video-mobile')
        : root.getAttribute('data-video-desktop');
      if (!src) return;

      var media = root.querySelector('[data-rx-bp-media]');
      if (!media) return;

      var posterEl = root.querySelector('.rx-bp__poster');
      var video = document.createElement('video');
      video.className = 'rx-bp__video';
      video.src = src;
      video.muted = true;
      video.defaultMuted = true;
      video.loop = true;
      video.autoplay = true;
      video.playsInline = true;
      video.setAttribute('playsinline', '');
      video.setAttribute('aria-hidden', 'true');
      video.preload = 'metadata';
      if (posterEl && posterEl.currentSrc) video.poster = posterEl.currentSrc;

      media.appendChild(video);

      var playAttempt = video.play();
      if (playAttempt && typeof playAttempt.catch === 'function') {
        playAttempt.catch(function () {
          video.remove(); /* autoplay blocked — keep the poster */
        });
      }
    }

    /* ---------- Countdown ---------- */
    var intro = root.querySelector('[data-rx-bp-intro]');
    var countdown = root.querySelector('[data-rx-bp-countdown]');
    var dateLine = root.querySelector('[data-rx-bp-date]');
    var enterBtn = root.querySelector('[data-rx-bp-enter]');
    var target = Date.parse(root.getAttribute('data-target-utc') || '');
    var liveHeading = root.getAttribute('data-live-heading');
    var countdownTimer = null;
    var reachedZero = false;

    var out = {
      days: root.querySelector('[data-rx-bp-days]'),
      hours: root.querySelector('[data-rx-bp-hours]'),
      minutes: root.querySelector('[data-rx-bp-minutes]'),
      seconds: root.querySelector('[data-rx-bp-seconds]')
    };

    function pad(n) {
      return n < 10 ? '0' + n : String(n);
    }

    function render() {
      if (isNaN(target)) return;
      var diff = target - Date.now();
      if (diff <= 0) {
        onZero();
        return;
      }
      var total = Math.floor(diff / 1000);
      if (out.days) out.days.textContent = String(Math.floor(total / 86400));
      if (out.hours) out.hours.textContent = pad(Math.floor((total % 86400) / 3600));
      if (out.minutes) out.minutes.textContent = pad(Math.floor((total % 3600) / 60));
      if (out.seconds) out.seconds.textContent = pad(total % 60);
    }

    function onZero() {
      if (reachedZero) return;
      reachedZero = true;
      if (countdownTimer) window.clearInterval(countdownTimer);
      if (countdown) countdown.hidden = true;
      if (intro && liveHeading) intro.textContent = liveHeading;
      if (dateLine) dateLine.hidden = true;
      if (enterBtn) enterBtn.hidden = false;
      scheduleRetries();
    }

    /* ---------- Restrained auto-retry after launch ---------- */
    function readRetries() {
      try {
        return parseInt(window.sessionStorage.getItem(RETRY_KEY) || '0', 10) || 0;
      } catch (e) {
        return MAX_RETRIES;
      }
    }

    function writeRetries(n) {
      try {
        window.sessionStorage.setItem(RETRY_KEY, String(n));
      } catch (e) {
        /* storage unavailable — the manual button still works */
      }
    }

    function scheduleRetries() {
      /* Never navigate away while the merchant is editing in Customize. */
      if (isDesignMode()) return;
      var attempt = function () {
        if (isDesignMode()) return;
        var used = readRetries();
        if (used >= MAX_RETRIES) return;
        writeRetries(used + 1);
        window.location.assign(root.getAttribute('data-root-url') || '/');
      };
      later(function () {
        attempt();
        every(attempt, RETRY_INTERVAL_MS);
      }, FIRST_RETRY_MS);
    }

    if (!isNaN(target)) {
      render();
      countdownTimer = every(render, 1000);
    }

    /* ---------- Team access modal ---------- */
    var modal = root.querySelector('[data-rx-bp-modal]');
    var openBtn = root.querySelector('[data-rx-bp-open]');
    var lastFocused = null;

    function focusables() {
      if (!modal) return [];
      return Array.prototype.slice.call(
        modal.querySelectorAll(
          '.rx-bp__dialog button, .rx-bp__dialog input, .rx-bp__dialog [href], .rx-bp__dialog select, .rx-bp__dialog textarea, .rx-bp__dialog [tabindex]:not([tabindex="-1"])'
        )
      ).filter(function (el) {
        return !el.disabled && (el.offsetParent !== null || el === document.activeElement);
      });
    }

    function openModal() {
      if (!modal) return;
      lastFocused = document.activeElement;
      modal.hidden = false;
      if (openBtn) openBtn.setAttribute('aria-expanded', 'true');
      document.documentElement.classList.add('rx-bp--modal-open');
      var input = modal.querySelector('input[type="password"]');
      if (input) input.focus();
      on(document, 'keydown', onKeyDown);
    }

    function closeModal() {
      if (!modal) return;
      modal.hidden = true;
      if (openBtn) openBtn.setAttribute('aria-expanded', 'false');
      document.documentElement.classList.remove('rx-bp--modal-open');
      document.removeEventListener('keydown', onKeyDown);
      if (lastFocused && lastFocused.focus) lastFocused.focus();
    }

    function onKeyDown(e) {
      if (e.key === 'Escape') {
        e.preventDefault();
        closeModal();
        return;
      }
      if (e.key !== 'Tab') return;
      var items = focusables();
      if (!items.length) return;
      var first = items[0];
      var last = items[items.length - 1];
      if (e.shiftKey && document.activeElement === first) {
        e.preventDefault();
        last.focus();
      } else if (!e.shiftKey && document.activeElement === last) {
        e.preventDefault();
        first.focus();
      }
    }

    if (openBtn) on(openBtn, 'click', openModal);
    Array.prototype.forEach.call(root.querySelectorAll('[data-rx-bp-close]'), function (el) {
      on(el, 'click', closeModal);
    });

    /* A wrong password re-renders the page with form.errors — reopen the modal. */
    if (modal && modal.querySelector('.rx-bp__error')) openModal();

    mountVideo();

    var instance = {
      root: root,
      destroy: function () {
        timers.forEach(function (id) {
          window.clearTimeout(id);
          window.clearInterval(id);
        });
        listeners.forEach(function (l) {
          l[0].removeEventListener(l[1], l[2]);
        });
        document.removeEventListener('keydown', onKeyDown);
        document.documentElement.classList.remove('rx-bp--modal-open');
        timers = [];
        listeners = [];
        root.rxBpBound = false;
      }
    };
    instances.push(instance);
  }

  function initAll(scope) {
    var container = scope || document;
    var nodes = container.querySelectorAll ? container.querySelectorAll('[data-rx-bp]') : [];
    Array.prototype.forEach.call(nodes, init);
    if (container.matches && container.matches('[data-rx-bp]')) init(container);
  }

  function destroyIn(scope) {
    instances = instances.filter(function (inst) {
      if (!scope || scope === document || (scope.contains && scope.contains(inst.root))) {
        inst.destroy();
        return false;
      }
      return true;
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () {
      initAll(document);
    });
  } else {
    initAll(document);
  }

  /* Shopify Customize: re-initialise on section re-render, clean up on removal. */
  document.addEventListener('shopify:section:load', function (event) {
    destroyIn(event.target);
    initAll(event.target);
  });

  document.addEventListener('shopify:section:unload', function (event) {
    destroyIn(event.target);
  });

  document.addEventListener('shopify:section:select', function (event) {
    initAll(event.target);
  });
})();
